import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { ValidTextRegExp } from "../../../Constant";
import MyContext from "../../../contexts/MyContext";
import { FormWrapper } from "../FormWrapper";

export const SingleTicketForm1 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");
  const validate = async () => {
    if (myContext.biljettnummerValue?.trim()?.length > 14) setBiljettnummerValueErr("bus_single_ticket_error_mesg");
    else {
      setBiljettnummerValueErr("");
      myContext.changeActiveSlide((myContext.activeSlide += 1));
    }
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper onContinue={validate} hasBackButton={false} number={`1/5`} heading={`${t("single_ticket")}`}>
            <MyTextField
              autoComplete="on"
              regExp={ValidTextRegExp}
              helperText={t(biljettnummerValueErr)}
              value={context.biljettnummerValue}
              label={t("ticket_number")}
              onChange={context.changeBiljettnummerValue}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
              maxLength={14}
            />
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
